import React, { useState } from "react";
import { X } from "lucide-react";
import CurrencyToggle from "../currencyToggle";
import { useSelector } from "react-redux";
import currencyPairCheck from "../../utilities/currencyPairCheck";
import { ArrowDown2, PercentageCircle, ReceiptDiscount } from "iconsax-reactjs";

const FundViaConversionModal = ({ isOpen, onClose }) => {
    const [amount, setAmount] = useState("");
    const { business, currency: defaults } = useSelector((state) => state);
    const businessId = business?._id;

    const rate = 1.7; // €1 = 1.7 USDC
    const ngnPerEuro = 1500; // NGN/EUR rate (can be dynamic if needed)
    const feeFlat = 300; // Fee in NGN — replace with dynamic value or percentage if needed

    const convertedAmountInEuro = amount ? amount / rate : 0;
    const totalFundSource = convertedAmountInEuro * ngnPerEuro + (amount ? feeFlat : 0);
    const isBusinessApproved = business?.status === "APPROVED";

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[700] bg-black/30 flex items-center justify-center">
            <div className="bg-white rounded-2xl w-[90%] max-w-xl p-6 relative">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-semibold text-[#101828]">Convert funds to USDC</h2>
                    <button onClick={onClose}>
                        <X size={24} color="#101828" />
                    </button>
                </div>

                <div>
                    <p className="text-sm font-medium text-[#6F6B7B] mb-2">Amount to fund</p>
                    <div className="flex items-center border-b border-[#E5E7EB] pb-1 text-[#6F6B7B]">
                        <input
                            type="number"
                            className="text-[64px] font-[350] w-full text-[#161827] bg-transparent outline-none placeholder:text-[#E5E7EB] placeholder:text-[64px]"
                            placeholder="0"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        {/* <CurrencyToggle
                            className="w-full text-sm bg-transparent"
                            dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
                            fetchWallet={true}
                            businessId={businessId}
                            isDisabled={!isBusinessApproved}
                            hideLabel={true}
                        /> */}
                    </div>
                    <p className="text-sm text-[#6F6B7B] mt-2">
                        ≈ ${(amount * rate).toLocaleString()}
                    </p>
                </div>

                <div className="relative my-6">
                    {/* Top horizontal line */}
                    <div className="absolute top-0 left-0 right-0 h-px bg-[#E1E3F4]" />
                    {/* Bottom horizontal line */}
                    <div className="absolute bottom-0 left-0 right-0 h-px bg-[#E1E3F4]" />
                    {/* Vertical arrow line with tail */}
                    <div className="absolute left-4 top-[0px] bottom-[0px] w-px bg-[#E1E3F4] z-0" />
                    <span className="absolute left-[9px] top-[111px]">
                        {" "}
                        <ArrowDown2 size={16} color="#E1E3F4" />
                    </span>

                    <div className="py-4 space-y-6 grid items-center">
                        {/* Fee */}
                        <div className="flex items-start gap-3 relative z-10">
                            <div className="w-8 h-8 rounded-full bg-[#F3F4FB] flex items-center justify-center">
                                <ReceiptDiscount size={16} color="#6F739B" variant="Bulk" />
                            </div>
                            <div className="flex justify-between mt-1.5 items-center w-full text-sm text-[#6F6B7B]">
                                <span>Fee</span>
                                <span>
                                    {currencyPairCheck(defaults)}
                                    {feeFlat.toLocaleString()}
                                </span>
                            </div>
                        </div>

                        {/* Rate */}
                        <div className="flex items-start gap-3 relative z-10">
                            <div className="w-8 h-8 rounded-full bg-[#F3F4FB] flex items-center justify-center">
                                <PercentageCircle size={16} color="#6F739B" variant="Bulk" />
                            </div>
                            <div className="flex justify-between mt-1.5 items-center w-full text-sm text-[#6F6B7B]">
                                <span>Rate</span>
                                <span>
                                    {currencyPairCheck(defaults)}1 = {rate} USDC
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-between items-center mb-1">
                    <p className="text-sm text-[#6F6B7B] font-medium">Fund source</p>
                    <CurrencyToggle
                        className=""
                        dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
                        isDisabled={!isBusinessApproved}
                        fetchWallet
                        businessId={business?._id}
                    />
                </div>

                <div>
                    <div className="flex items-baseline gap-1">
                        <span className="relative bottom-5 text-[24px] font-[350] text-[#101828]">
                            {currencyPairCheck(defaults)}
                        </span>
                        <input
                            readOnly
                            type="text"
                            value={totalFundSource.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                            })}
                            className="text-[64px] font-[350] text-[#101828] bg-transparent border-none outline-none w-full overflow-x-auto whitespace-nowrap"
                        />
                    </div>
                    <div className="text-[#6F6B7B] text-sm mt-1">
                        Balance: <span>{currencyPairCheck(defaults)}</span>30,200
                    </div>
                </div>

                <div className="flex justify-end gap-3 !border-2 !border-t mt-6">
                    <button onClick={onClose} className="text-[#101828] text-sm font-medium">
                        Back
                    </button>
                    <button className="bg-[#6F00FF] text-white px-6 py-2 rounded-xl font-medium text-sm">
                        Fund wallet
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FundViaConversionModal;
